import { DefaultButton, Dialog, DialogFooter, DialogType, PrimaryButton, Stack, TextField } from '@fluentui/react';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { CommentMode } from '../../Utility/AppEnums';
import { Utility } from '../../Utility/Utility';
import './Common.scss';
export interface IModalCommentProps {
    header: string;
    message: string;
    buttonYesText: string;
    buttonCancelText: string;
    confirmed: any;
    hideConfirmedDialog: any;
}


export const Confirmation: React.FunctionComponent<IModalCommentProps> = ({ ...props }) => {
    useEffect(() => {

    });

    return (
        <>

            <Dialog
                hidden={false}
                onDismiss={props.hideConfirmedDialog}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: props.header,
                    subText: props.message,
                }}
                modalProps={{
                    isBlocking: true,
                    className: "appConfirmationBox"
                    // styles: { main: { maxWidth: 800 } },
                }}
            >
                <DialogFooter>
                    <PrimaryButton onClick={() => props.confirmed()} text={props.buttonYesText} />
                    <DefaultButton onClick={() => props.hideConfirmedDialog()} text={props.buttonCancelText} />
                </DialogFooter>
            </Dialog>
        </>
    );
};
